import { render, staticRenderFns } from "./YouthArticles.vue?vue&type=template&id=f50a3b8a&"
import script from "./YouthArticles.vue?vue&type=script&lang=js&"
export * from "./YouthArticles.vue?vue&type=script&lang=js&"
import style0 from "./YouthArticles.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports